<template>
  <div class="XVradiobuttonlist radiobuttonlist pointer">
    <div
      v-for="(listitem, index) in datalist"
      :key="index"
      @click.prevent="clickradio(listitem.value)"
      class="radioholder margin10"
    >
      <label class="input-radio pointer" :class="[radiobuttonsright ? 'pull-right' : '']">
        <input
          :disabled="disabled"
          type="radio"
          v-focus="focus === true && index === 0"
          :value="listitem.value"
          :checked="listitem.value == value"
          :name="id"
          :id="id + listitem.value"
        />
        <span></span>
      </label>
      <label class="radiolabel pointer">{{ listitem.labelText }}</label>
      <slot name="afterLabel" :item="listitem"></slot>
    </div>
    <!-- <span>{{$v}}</span> -->
  </div>
</template>

<script>
export default {
  name: 'XVradiobuttonlist',
  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    datalist: {
      type: Array,
      required: true
    },
    value: {},
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    },
    radiobuttonsright: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      checkedindex: ''
    }
  },
  methods: {
    clickradio: function(val) {
      if (this.disabled === true) {
        return false
      }
      this.checkedindex = val
      this.$emit('input', val) // prop value en deze input event handler zorgen er voor dat je een v-model kan toepassen op dit custom component
      this.$emit('formvaluechanged', {
        type: this.$vnode.componentOptions.tag,
        value: val,
        id: this.id,
        formdata: this.formdata
      })
    }
  }
}
</script>
